import styled from "@emotion/styled";

export const StyleModalWrapper = styled.div<any>`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0px;
  z-index: 99999999;
`;

export const StyleModalOverlay = styled.div<any>`
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; /* 👈 Center vertically */
  transition: background 0.3s ease-in;
`;

export const StyleModalCard = styled.div<any>`
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 20px;
  position: relative;
  overflow-y: auto;
  padding: ${(props: any) => props.padding || "16px 14px"} !important;
  max-height: 800px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);

  transform: scale(0.6);
  opacity: 0;
  animation: scaleInCenter 0.3s ease-out forwards;

  @keyframes scaleInCenter {
    from {
      transform: scale(0.6);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @media (max-width: 640px) {
    width: 80%;
  }

  width: ${(props) =>
    typeof props.size == "string" ? props.size : `${props.size}px}`};
  height: ${(props) =>
    typeof props.height == "string" ? props.height : `${props.height}px}`};
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyleModalCardHeader = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  padding: 15px 20px;
`;
export const StyleModalCardTitle = styled.h2<any>`
  font-size: 16px;
  color: ${(props: any) => props.theme.colors.primary};
`;
export const StyleModalCardBody = styled.div<any>``;

export const StyleCancelButton = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  color: ${(props: any) => props.theme.colors.red500};
  font-weight: 400;
  cursor: pointer;
  transition: all 300ms linear;
  border-radius: 100vh;
  z-index: 99999999999999;
  &:hover {
    scale: 1.07;
  }
  &:active {
    scale: 0.9;
  }
`;
